import React from "react";
import { Monitor, FileText, X } from "lucide-react";

const PartnerRejectionDialog = ({ isOpen, onClose, order, onGoToPartnerApp }) => {
  if (!isOpen) return null;

  const isSwiggy = order?.partnerName?.toLowerCase() === "swiggy";
  const themeColor = isSwiggy ? "bg-orange-500" : "bg-red-600";
  const buttonColor = isSwiggy ? "bg-orange-600" : "bg-red-600";
  const partnerName = isSwiggy ? "Swiggy" : "Zomato";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop with blur */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      {/* Dialog */}
      <div className="relative bg-white rounded-3xl shadow-xl max-w-md w-full mx-4 z-50 p-8">
        {/* Title */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold mb-2">
            Order Rejection is a critical step{" "}
            <span className={`inline-flex items-center justify-center w-6 h-6 ${themeColor} text-white rounded-full`}>!</span>
          </h2>
          <p className="text-gray-600">
            Please go to your {partnerName} partner web application and reject the order.
          </p>
        </div>

        {/* Flow Steps */}
        <div className="space-y-4 mb-8">
          <h3 className="font-semibold text-lg">Flow as follows:</h3>
          
          <div className="flex items-center gap-3">
            <Monitor className="w-6 h-6 text-gray-700" />
            <span>Open {partnerName} Partner Web</span>
          </div>
          
          <div className="flex items-center gap-3">
            <FileText className="w-6 h-6 text-gray-700" />
            <span>See order details</span>
          </div>
          
          <div className="flex items-center gap-3">
            {isSwiggy ? (
              <div className="w-6 h-6 flex items-center justify-center border-2 border-gray-700 rounded">✓</div>
            ) : (
              <X className="w-6 h-6 text-gray-700" />
            )}
            <span>{isSwiggy ? "Mark out of stock" : "Reject the order"}</span>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={onGoToPartnerApp}
          className={`w-full ${buttonColor} text-white py-3 px-4 rounded-xl font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity`}
        >
          Go to {partnerName} Web App
          <span className="text-xl">→</span>
        </button>
      </div>
    </div>
  );
};

export default PartnerRejectionDialog; 